
import { AppSteppers, AppSteppersPane } from '@/uikit/components/AppSteppers';
import Button from '@/components/ext/Button.vue';
import DynamicAdditionalDataForm from '@/components/ordersProcessForms/parts/AdditionalDataStep/DynamicAdditionalDataForm.vue';
import ActivitesOrder from '@/pages/activities/card/order';
import FinishMessage from '../parts/finishMessage';
import ActivitiesOrderRequirements from '@/pages/activities/card/order/ActivitiesOrderRequirements.vue';

export default {
  props: {
    orderBinds: {},
  },
  components: {
    ActivitiesOrderRequirements,
    AppSteppersPane,
    DynamicAdditionalDataForm,
    Button,
    AppSteppers,
    ActivitesOrder,
    FinishMessage,
  },
  data() {
    return {
      finishMsg: {},
      file: undefined,
      answer: undefined,
    };
  },
  methods: {
    setFinishMsg($event: any) {
      this.finishMsg = $event;
    },
    requirementsNextStep(
      nextStep: Function,
      answer: string = undefined,
      file: string = undefined
    ) {
      this.answer = answer;
      this.file = file;
      nextStep();
    },
  },
};



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ordersProcessForms/activity/ActivityOrderProcess.vue